import httpClient from '../httpClient';

const websocketPath = (routePath: TemplateStringsArray) =>
  `websockets/${routePath}`;

function getToken() {
  return httpClient.get<{ token: string }>(websocketPath`token`);
}

export default {
  getToken,
};
